// extracted by mini-css-extract-plugin
export default {"container":"History_container__cH8sI","historyTable":"History_historyTable__xDTgt","spinner":"History_spinner__K88yI"};